import { render, staticRenderFns } from "./data2.vue?vue&type=template&id=067e4a1f&scoped=true"
import script from "./data2.vue?vue&type=script&lang=js"
export * from "./data2.vue?vue&type=script&lang=js"
import style1 from "./data2.vue?vue&type=style&index=1&id=067e4a1f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067e4a1f",
  null
  
)

export default component.exports